import { Button, CircularProgress, Link, Stack, TextField, Typography } from "@mui/material"
import { memo, useState } from "react"
import { z } from "zod"
import { PasswordTextField } from "app/components/PasswordTextField"
import type { OnLoginWithEmail } from "interface/types/onLoginWithEmail"
import { t } from "lib/i18n"

const zForm = z.object({
  email: z.string(),
  password: z.string(),
})

type Props = {
  isLoading: boolean
  onLogin: OnLoginWithEmail
}

export const HomeLoginForm = memo<Props>((props) => {
  const [email, setEmail] = useState("")

  const [password, setPassword] = useState("")

  const onSubmit = () => {
    // Form submission
    const form = zForm.parse({ email, password })
    props.onLogin(form)
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onSubmit()
      }}
    >
      <Stack spacing={2}>
        <Stack spacing={4}>
          <Stack spacing={2}>
            <TextField
              size={"small"}
              label={t("Email")}
              placeholder={t("Email")}
              autoFocus
              autoComplete={"email"}
              disabled={props.isLoading}
              value={email}
              onChange={(event) => {
                setEmail(event.target.value)
              }}
            />
            <PasswordTextField
              label={t("Password")}
              size={"small"}
              placeholder={t("Password")}
              autoComplete="password"
              disabled={props.isLoading}
              value={password}
              onChange={(event) => {
                setPassword(event.target.value)
              }}
            />
          </Stack>
          <Button
            type={"submit"}
            variant="contained"
            disabled={props.isLoading}
            startIcon={props.isLoading ? <CircularProgress size={20} /> : null}
          >
            {t("Sign in")}
          </Button>
        </Stack>
        <Stack alignItems="flex-start">
          <Link href={"/reset"}>
            <Button type="button" variant="text" color="primary">
              {t("Forgot your password?")}
            </Button>
          </Link>
          <Typography variant="body2" ml={1}>
            {t("Don't have an account?")}
            <Link href={"/register"} ml={1} underline="none">
              {t("Sign Up")}
            </Link>
          </Typography>
        </Stack>
      </Stack>
    </form>
  )
})
